import React, { useEffect, useRef } from 'react';

interface TextDisplayProps {
  currentText: string;
  textProgress: number;
  isPlaying: boolean;
  isLoading: boolean;
  audioUrl: string | null;
  conversationStarted: boolean;
}

const TextDisplay: React.FC<TextDisplayProps> = ({
  currentText,
  textProgress,
  isPlaying,
  isLoading,
  audioUrl,
  conversationStarted,
}) => {
  const textContainerRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when text changes
  useEffect(() => {
    if (textContainerRef.current) {
      textContainerRef.current.scrollTop = textContainerRef.current.scrollHeight;
    }
  }, [currentText]);

  // Show text if we have any currentText, regardless of isPlaying status
  if (currentText) {
    return (
      <>
        <div
          ref={textContainerRef}
          style={{
            fontSize: '22px',
            lineHeight: '1.5',
            color: '#2c3e50',
            marginBottom: '15px',
            fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
            fontWeight: '400',
            textAlign: 'left',
            maxHeight: '132px', // Max height for ~4 lines (22px font * 1.5 line height * 4 lines)
            overflow: 'hidden',
            overflowY: 'auto',
            scrollBehavior: 'smooth',
          }}
        >
          <div style={{
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end'
          }}>
            <span>
              {currentText}
              {isPlaying && (
                <span style={{
                  animation: 'blink 1s infinite',
                  color: '#4ecdc4',
                  fontSize: '24px',
                  fontWeight: '300',
                }}>|</span>
              )}
            </span>
          </div>
        </div>
        {(isPlaying || textProgress > 0) && (
          <div style={{
            width: '100%',
            height: '4px',
            background: '#f8f9fa',
            borderRadius: '3px',
            overflow: 'hidden',
            marginTop: '10px',
          }}>
            <div style={{
              width: `${textProgress}%`,
              height: '100%',
              background: 'linear-gradient(90deg, #4ecdc4, #44a08d)',
              borderRadius: '3px',
              transition: 'width 0.1s ease-out',
              boxShadow: '0 0 8px rgba(78, 205, 196, 0.3)',
            }} />
          </div>
        )}
      </>
    );
  }

  return (
    <div style={{
      fontSize: '18px',
      color: '#7f8c8d',
      fontStyle: 'italic',
      textAlign: 'center',
      fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    }}>
      {isLoading ? (
        <span style={{ color: '#4ecdc4' }}>⏳ Generating speech...</span>
      ) : audioUrl && !conversationStarted ? (
        'Click the Start button to begin!'
      ) : (
        'Click Start to meet Ellie'
      )}
    </div>
  );
};

export default TextDisplay;